import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { RegisterEntity } from "../../Objects/Register/RegisterEntity"
import { useTranslation } from "react-i18next"

export const useGetRegister = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGet = async (onSuccess: any, id: string | number, typeEntity: string): Promise<RegisterEntity[]> => {
    enableLoad()

    try {
      const response = await GetRequest<RegisterEntity[]>(
        `${API_ROUTES.REGISTER.GET_ALL}/${id}/related?target=${typeEntity}`,
      )

      if (response.success) {
        const temp = response.data?.map((e) => new RegisterEntity(e)) ?? []

        onSuccess()

        return temp
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
      return []
    } finally {
      disableLoad()
    }
  }

  return {
    handleGet,
  }
}
